import type {DmsRouteCatalogPaths} from './types/DmsRouteCatalogPath';

export function filterReachableRouteIds(
  catalog: DmsRouteCatalogPaths,
  registeredPaths: readonly string[],
  dynamicAccess: Readonly<Record<string, boolean>>
): string[] {
  const registeredPathSet = new Set(registeredPaths);

  return catalog
    .filter(
      (route) =>
        registeredPathSet.has(route.pathTemplate) &&
        (route.dynamicAccess === undefined || dynamicAccess[route.dynamicAccess] === true)
    )
    .map((route) => route.routeId);
}
